/**
 * Bundle Image Swap Animation
 * Click on either image to swap their positions with a shuffle animation
 */
document.addEventListener('DOMContentLoaded', function() {
  // Get all bundle image containers
  const bundleImageContainers = document.querySelectorAll('.bundle-images');

  bundleImageContainers.forEach(container => {
    const images = container.querySelectorAll('.bundle-image');

    images.forEach(image => {
      image.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
       console.log('LOADED FILE')
        // Don't allow clicking while animating
        if (container.classList.contains('animating')) {
          return;
        }

        // Add animating class for the shuffle effect
        container.classList.add('animating');

        // Toggle the swapped state
        container.classList.toggle('swapped');

        // Remove animating class after animation completes
        setTimeout(() => {
          container.classList.remove('animating');
        }, 500); // Match the CSS animation duration
      });
    });
  });
});